import React, { useState, useEffect } from 'react';
import _, { find, isEmpty, map } from 'lodash';
import { makeStyles } from 'tss-react/mui';
import { Grid, FormControl } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import 'react-phone-number-input/style.css';
import styles from '../../../EditDevice/editDevice.styles.js';
import moment from 'moment';
import 'moment/locale/ar';
import {
  FormControlLabel,
  MenuItem,
  Chip,
  OutlinedInput,
  Autocomplete,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { getTimeZoneOffsetInteger } from '../../../utils/index.js';
import Button from '../../../components/Button';
import TextInput from '../../../components/TextInput';
import Switch from '../../../components/Switch';
import SelectInput from '../../../components/SelectInput.jsx';
import Select from '@mui/material/Select';
import { getProfessionalCaregiver, createUserDoctorVisit } from '../../../utils/api';
import { useQuery } from 'react-query';
import { VISIT_TYPES, COMMON_SYMPTOMS } from '../../DoctorVisit/utils/visitUtils';
import colors from '../../../shared-colors';
import SnackbarComponent from '../../../components/Snackbar';
const useStyles = makeStyles()(styles);

const EVENT_TYPE = [
  {
    titleKey: 'socialVisit',
    key: 'social_visit',
    color: '#BF76F6',
  },
  {
    titleKey: 'appointment',
    key: 'appointment',
    color: '#FFC007',
  },
  {
    titleKey: 'task',
    key: 'task',
    color: '#5CB85B',
  },
  {
    titleKey: 'doctorVisit',
    key: 'doctor_visit',
    color: '#BF76F6',
  },
];
const WEEK_DAYS = [
  { name: 'Sun' },
  { name: 'Mon' },
  { name: 'Tue' },
  { name: 'Wed' },
  { name: 'Thur' },
  { name: 'Fri' },
  { name: 'Sat' },
];

function AddEvents({ user, closeModal, refreshEvents, selectedRecipient, caregivers }) {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [loader, setLoader] = useState(false);
  const [state, setState] = useState({
    title: '',
    description: '',
    type: '',
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    assignee: '',
    repeat: false,
    errorMessage: '',
    weekDayFrequency: [],
    remindMe: '',
    location: '',
    doctorId: '',
    visitType: '',
    symptoms: [],
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const { data: professionalCaregiver, isLoading } = useQuery({
    queryKey: ['professionalCaregiver', user?._id],
    queryFn: () => getProfessionalCaregiver({ userId: user?._id }),
  });
  const professionalCaregiverData = professionalCaregiver?.data;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const {
        title,
        description,
        type,
        startDate,
        endDate,
        startTime,
        endTime,
        doctorId,
        assignee,
        repeat,
        weekDayFrequency,
        remindMe,
        location,
      } = state;
      if (isEmpty(title)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Title cannot be empty!' };
        });
        return;
      }

      if (isEmpty(type)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Event type must be selected!' };
        });
        return;
      }

      if (isEmpty(startDate)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Start date cannot be empty!' };
        });
        return;
      }

      if (isEmpty(endDate)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'End date cannot be empty!' };
        });
        return;
      }

      if (isEmpty(startTime)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Start time cannot be empty!' };
        });
        return;
      }

      if (isEmpty(endTime)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'End time cannot be empty!' };
        });
        return;
      }
      if (state.type === 'doctor_visit' && isEmpty(doctorId)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Professional Caregiver cannot be empty!' };
        });
        return;
      }
      if (moment(startDate).unix() > moment(endDate).unix()) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Start date cannot be passed from end date!' };
        });
        return;
      }

      const [startHour, startMin] = state.startTime.split(':');
      const [endHour, endMin] = state.endTime.split(':');

      if (parseInt(startHour) > parseInt(endHour)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Start time should be before end time!' };
        });
        return;
      }

      if (parseInt(startHour) === parseInt(endHour)) {
        if (parseInt(startMin) > parseInt(endMin)) {
          setState((prevState) => {
            return { ...prevState, errorMessage: 'Start time should be before end time!' };
          });
          return;
        }
      }

      if (repeat && isEmpty(weekDayFrequency)) {
        setState((prevState) => {
          return { ...prevState, errorMessage: 'Must select one or more day!' };
        });
        return;
      }

      setState((prevState) => {
        return { ...prevState, errorMessage: '' };
      });

      const body = {
        title,
        description,
        type,
        color: find(EVENT_TYPE, (item) => item?.key === type)?.color || '',
        startDate,
        endDate,
        startTime,
        endTime,
        assignee,
        doctorId,
        repeat,
        weekDayFrequency,
        remindMe,
        location,
        timezone: getTimeZoneOffsetInteger(),
      };
      const userId = user?.id || user?._id;
      setLoader(true);
      if (isEmpty(selectedRecipient)) {
        await axios.post(process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/event`, body, {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        });
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${userId}/userEvents/${selectedRecipient}`,
          body,
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      refreshEvents();
      closeModal();
    } catch (error) {
      console.log('error =====> ', error);
      setState((prevState) => {
        return {
          ...prevState,
          errorMessage: error?.response?.data?.message || 'Something went wrong!',
        };
      });
    } finally {
      setLoader(false);
    }
  };
  const handleCreateDoctorVisit = async () => {
    // Validate required fields
    if (!state.doctorId) {
      setSnackbar({
        open: true,
        message: 'Please select a doctor',
        severity: 'error',
      });
      return;
    }
    if (!state.visitType) {
      setSnackbar({
        open: true,
        message: 'Please select a visit type',
        severity: 'error',
      });
      return;
    }

    const body = {
      title: state.title,
      description: state.description,
      doctorId: state.doctorId,
      visitType: state.visitType,
      symptoms: state.symptoms,
      location: state.location,
      startDate: state.startDate,
      endDate: state.endDate,
      startTime: state.startTime,
      endTime: state.endTime,
      timezone: new Date().getTimezoneOffset() / -60,
    };
    const response = await createUserDoctorVisit({ userId: user?._id, body });
    if (response.statusCode === 200) {
      setSnackbar({
        open: true,
        message: 'Doctor visit created successfully!',
        severity: 'success',
      });
      closeModal();
      refreshEvents();
    } else {
      setSnackbar({
        open: true,
        message: 'Failed to create doctor visit',
        severity: 'error',
      });
    }
  };
  const handleSetWeekDays = (name) => {
    if (state.weekDayFrequency.includes(name)) {
      setState((prev) => {
        return {
          ...prev,
          weekDayFrequency: prev.weekDayFrequency.filter((item) => item !== name),
        };
      });
    } else {
      setState((prev) => {
        return {
          ...prev,
          weekDayFrequency: [...prev.weekDayFrequency, name],
        };
      });
    }
  };

  const handleSetAddress = (address) => {
    if (address?.formatted_address) {
      setState((prev) => {
        return {
          ...prev,
          location: address?.formatted_address,
        };
      });
    }
  };
  const remindMeOptions = [
    { value: '5 minutes', label: t('remind_5min') },
    { value: '10 minutes', label: t('remind_10min') },
    { value: '30 minutes', label: t('remind_30min') },
  ];

  const handleSymptomAdd = (symptom) => {
    if (symptom && !state.symptoms.includes(symptom)) {
      setState((prev) => ({
        ...prev,
        symptoms: [...prev.symptoms, symptom],
      }));
    }
  };

  const handleSymptomRemove = (symptomToRemove) => {
    setState((prev) => ({
      ...prev,
      symptoms: prev.symptoms.filter((symptom) => symptom !== symptomToRemove),
    }));
  };

  // Function to get selected doctor name
  const getSelectedDoctorName = () => {
    if (!state.doctorId || !professionalCaregiverData) return '';
    const selectedDoctor = professionalCaregiverData.find((doctor) => doctor.userInfo._id === state.doctorId);
    return selectedDoctor ? `${selectedDoctor.userInfo.firstName} ${selectedDoctor.userInfo.lastName}` : '';
  };

  return (
    <div className={classes.paper}>
      <Grid container item direction="row" justify="space-between" alignItems="center" className={classes.header}>
        <Grid item className={classes.title}>
          {t('createTask')}
        </Grid>
        <Grid item className={classes.closeIcon} onClick={closeModal}>
          <CloseIcon />
        </Grid>
      </Grid>

      <Grid item className={classes.userInfoPanel} style={{ marginTop: '20px' }}>
        <div className={classes.newCaregiver}>
          <Grid item className={classes.deviceInfoPart}>
            <TextInput
              label={t('taskName')}
              fullWidth
              value={state.title}
              onChange={(e) =>
                setState((prevState) => {
                  return { ...prevState, title: e.target.value };
                })
              }
            />
          </Grid>
        </div>
      </Grid>

      <Grid item className={classes.userInfoPanel}>
        <div className={classes.newCaregiver}>
          <Grid item className={classes.deviceInfoPart}>
            <TextInput
              label={t('describeTask')}
              fullWidth
              value={state.description}
              onChange={(e) =>
                setState((prevState) => {
                  return { ...prevState, description: e.target.value };
                })
              }
              multiline
            />
          </Grid>
        </div>
      </Grid>

      <Grid container style={{ width: '800px' }}>
        <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
          <div className={classes.newCaregiver}>
            <Grid item className={classes.deviceInfoPart}>
              <div className={classes.deviceInfoPartTitle}>
                {t('type')}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <FormControl variant="outlined" style={{ width: '190px', marginTop: '10px' }}>
                <Select
                  defaultValue=""
                  displayEmpty
                  fullWidth
                  onChange={(e) =>
                    setState((prevState) => {
                      return { ...prevState, type: e.target.value };
                    })
                  }
                  style={{ borderRadius: 50 }}
                >
                  <MenuItem value="" disabled>
                    -- {t('selectType')}--
                  </MenuItem>
                  {EVENT_TYPE.map(({ titleKey, key, color }, idx) => (
                    <MenuItem value={key} key={idx}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                          gap: '10px',
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: color,
                            height: 14,
                            width: 14,
                            borderRadius: '50%',
                            flexShrink: 0,
                          }}
                        />
                        <span style={{ flexGrow: 1 }}>{t(titleKey)}</span>
                      </div>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </div>
        </Grid>
        {state.type === 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('doctor')}</div>
                <FormControl fullWidth>
                  <Select
                    value={state.doctorId}
                    onChange={(e) =>
                      setState((prevState) => {
                        return { ...prevState, doctorId: e.target.value };
                      })
                    }
                    sx={{
                      borderRadius: 50,
                    }}
                  >
                    <MenuItem value="" disabled>
                      -- {t('selectDoctor')} --
                    </MenuItem>
                    {isLoading ? (
                      <MenuItem value="" disabled>
                        {t('loadingDoctors')}
                      </MenuItem>
                    ) : professionalCaregiverData && professionalCaregiverData.length > 0 ? (
                      professionalCaregiverData.map((doctor) => (
                        <MenuItem key={doctor._id} value={doctor._id}>
                          <Box>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              {doctor.userInfo.firstName} {doctor.userInfo.lastName}
                            </Typography>
                          </Box>
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="" disabled>
                        {t('noDoctorsAvailable')}
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        )}

        {state.type === 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('visitType')}</div>
                <FormControl variant="outlined" style={{ width: '190px', marginTop: '10px' }}>
                  <Select
                    defaultValue=""
                    displayEmpty
                    fullWidth
                    value={state.visitType}
                    onChange={(e) =>
                      setState((prevState) => {
                        return { ...prevState, visitType: e.target.value };
                      })
                    }
                    style={{ borderRadius: 50 }}
                  >
                    <MenuItem value="" disabled>
                      -- {t('selectVisitType')} --
                    </MenuItem>
                    {map(VISIT_TYPES, ({ value }, idx) => (
                      <MenuItem value={value} key={idx}>
                        {t(`visitTypes.${value.toLowerCase()}`)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        )}

        {state.type === 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('symptoms')}</div>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginTop: '10px' }}>
                  <Autocomplete
                    freeSolo
                    options={COMMON_SYMPTOMS}
                    value=""
                    onChange={(event, newValue) => {
                      if (newValue) {
                        handleSymptomAdd(newValue);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t('addSymptom')}
                        placeholder={t('typeOrSelectSymptom')}
                        InputProps={{
                          ...params.InputProps,
                          sx: {
                            borderRadius: 50,
                          },
                        }}
                        sx={{
                          '& .MuiInputLabel-root': {
                            background: '#fff',
                            px: 1,
                          },
                        }}
                      />
                    )}
                  />

                  {state.symptoms.length > 0 && (
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                      {state.symptoms.map((symptom, index) => (
                        <Chip
                          key={index}
                          label={symptom}
                          onDelete={() => handleSymptomRemove(symptom)}
                          sx={{
                            backgroundColor: colors.lightBlue,
                            color: colors.mainBlue,
                            fontWeight: 500,
                            borderRadius: 50,
                          }}
                        />
                      ))}
                    </Box>
                  )}
                </Box>
              </Grid>
            </div>
          </Grid>
        )}

        {state.type !== 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('assignee')}</div>
                <FormControl variant="outlined" style={{ width: '190px', marginTop: '10px' }}>
                  <Select
                    defaultValue=""
                    displayEmpty
                    fullWidth
                    value={state.assignee}
                    onChange={(e) =>
                      setState((prevState) => {
                        return { ...prevState, assignee: e.target.value };
                      })
                    }
                    style={{ borderRadius: 50 }}
                  >
                    <MenuItem value="" disabled>
                      -- {t('selectAssignee')} --
                    </MenuItem>
                    {map(caregivers, ({ userId, name }, idx) => (
                      <MenuItem value={userId} key={idx}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        )}
        {state.type !== 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('remindMe')}</div>
                <FormControl variant="outlined" style={{ width: '190px', marginTop: '10px' }}>
                  <Select
                    defaultValue=""
                    displayEmpty
                    fullWidth
                    value={state.remindMe}
                    onChange={(e) =>
                      setState((prev) => {
                        return { ...prev, remindMe: e.target.value };
                      })
                    }
                    style={{ borderRadius: 50 }}
                  >
                    <MenuItem value="" disabled>
                      -- {t('selectReminder')} --
                    </MenuItem>
                    {['5 minutes', '10 minutes', '30 minutes'].map((option, idx) => (
                      <MenuItem value={option} key={idx}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </div>
          </Grid>
        )}

        {state.type !== 'doctor_visit' && (
          <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
            <div className={classes.newCaregiver}>
              <Grid item className={classes.deviceInfoPart}>
                <div className={classes.deviceInfoPartTitle}>{t('location')}</div>

                <ReactGoogleAutocomplete
                  options={{
                    types: ['geocode'],
                    componentRestrictions: { country: 'us' },
                  }}
                  className="address-input"
                  apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                  onPlaceSelected={handleSetAddress}
                  style={{ borderRadius: 50, border: '0.5px solid grey', paddingLeft: '10px' }}
                />
              </Grid>
            </div>
          </Grid>
        )}
      </Grid>

      <Grid container style={{ width: '800px' }}>
        <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
          <div className={classes.newCaregiver}>
            <Grid item className={classes.deviceInfoPart}>
              <div className={classes.deviceInfoPartTitle}>
                {t('startDate')}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <FormControl variant="outlined">
                <input
                  style={{ width: '190px', borderRadius: 50 }}
                  type="date"
                  className={classes.deviceInfoInput}
                  onChange={(e) =>
                    setState((prevState) => {
                      return { ...prevState, startDate: e.target.value };
                    })
                  }
                />
              </FormControl>
            </Grid>
          </div>
        </Grid>
        <Grid item className={classes.userInfoPanel} lg={3} md={3} sm={12} xs={12}>
          <div className={classes.newCaregiver}>
            <Grid item className={classes.deviceInfoPart}>
              <div className={classes.deviceInfoPartTitle}>
                {t('endDate')}
                <span style={{ color: 'red' }}>*</span>
              </div>
              <FormControl variant="outlined">
                <input
                  style={{ width: '190px', borderRadius: 50 }}
                  type="date"
                  className={classes.deviceInfoInput}
                  onChange={(e) =>
                    setState((prevState) => {
                      return { ...prevState, endDate: e.target.value };
                    })
                  }
                  min={moment(state.startDate).format('YYYY-MM-DD')}
                />
              </FormControl>
            </Grid>
          </div>
        </Grid>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <div>
            {t('startTime')}
            <span style={{ color: 'red' }}>*</span>
          </div>
          <input
            style={{ width: '190px', borderRadius: 50 }}
            type="time"
            value={state.startTime}
            className={classes.deviceInfoInput}
            onChange={(e) =>
              setState((prevState) => {
                return { ...prevState, startTime: e.target.value };
              })
            }
          />
        </Grid>
        <Grid item lg={3} md={3} sm={12} xs={12}>
          <div>
            {t('endTime')}
            <span style={{ color: 'red' }}>*</span>
          </div>
          <input
            style={{ width: '190px', borderRadius: 50 }}
            type="time"
            value={state.endTime}
            className={classes.deviceInfoInput}
            onChange={(e) =>
              setState((prevState) => {
                return { ...prevState, endTime: e.target.value };
              })
            }
          />
        </Grid>
      </Grid>

      <Grid>
        <FormControlLabel
          control={
            <Switch
              onChange={() =>
                setState((prevState) => {
                  return { ...prevState, repeat: !prevState.repeat };
                })
              }
            />
          }
          label={t('repeatTask')}
        />
        {state.repeat && (
          <Grid item style={{ marginBlock: '20px' }}>
            <div>
              {WEEK_DAYS.map(({ name }) => (
                <span
                  className="weekDays"
                  style={{
                    color: state.weekDayFrequency.includes(name) ? '#fff' : 'black',
                    background: state.weekDayFrequency.includes(name) ? '#26786a' : '#fff',
                  }}
                  onClick={() => handleSetWeekDays(name)}
                >
                  {name.charAt(0)}
                </span>
              ))}
            </div>
          </Grid>
        )}
      </Grid>

      <Grid
        item
        direction="column"
        justify="flex-start"
        alignItems="center"
        className={classes.errorMessage}
        style={{ color: 'red', marginTop: '10px' }}
      >
        {state.errorMessage}
      </Grid>
      <div style={{ marginBlock: '20px', borderBottom: '0.5px solid grey' }} />
      <Grid container item direction="row" justify="space-between" alignItems="center" className={classes.footer}>
        <Grid item>
          <Button fullWidth bg="light" onClick={closeModal} text={t('cancel')} />
        </Grid>
        <Grid item>
          <Button
            loading={loader}
            fullWidth
            onClick={state.type === 'doctor_visit' ? handleCreateDoctorVisit : handleSubmit}
            text={t('add')}
          />
        </Grid>
      </Grid>

      <SnackbarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        handleClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
}

export default AddEvents;
